import React from "react";

import "./Input.css";

type InputProps = {
  id?: string;
  placeholder?: string;
  type?: string;
  value?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

 const Input: React.FC<InputProps> = ({
  id = "input-text",
  placeholder = "",
  type = "text",
  disabled = false,
  value="",
  onClick,
  onChange,
  className,
}) => {
  return (
    <input
      id={id}
      placeholder={placeholder}
      type={type}
      disabled={disabled}
      value={value}
      onClick={onClick}
      onChange={onChange}
      className={`custom-input ${className}`}
    />
  );
};

export default Input;